export const appStyles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: 64,
    zIndex: 1000,
  },
  logo: {
    height: '55px',
    marginRight: 20,
  },
  collapseButton: {
    marginRight: "auto",
  },
  userIcon: {
    height: 40,
    marginLeft: 20,
  },
  layout: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  content: {
    padding: "0 20px",
    marginTop: 64,
    overflow: "hidden", // Default to hidden overflow for larger screens

    // Ensure horizontal scroll on smaller screens
    // minWidth: "100vw", // Prevent content from overflowing
    // "@media (max-width: 768px)": {
    //   overflowX: "auto", // Enable horizontal scroll for smaller screens
    //   whiteSpace: "nowrap", // Prevent content wrapping, forcing horizontal scroll
    // },
  },
  menu: {
    display: "inline-block", // Prevent menu items from wrapping
    "@media (max-width: 768px)": {
      width: "100%", // Ensures menu takes up full width on smaller screens
    },
  },
  sidebar: {
    marginTop: 64,
  },
  userDetailContainer: {
    display: "flex",
    alignItems: "center",
  },
  "@media (max-width: 768px)": {
    header: {
      padding: "0 10px",
    },
    logo: {
      height: 30,
      marginRight: 10,
    },
    userIcon: {
      height: 30,
      marginLeft: 10,
    },
    userDetailContainer: {
      h2: {
        fontSize: "1rem",
      },
    },
  },
};
